import { createApp } from 'vue/dist/vue.esm-bundler.js'

{
  const appConfig = {
    data() {
      return {
        loading: true,
        directory: {},
        popupArticle: null
      }
    },
    mounted(){
      document.addEventListener('keydown', e => {
        if(this.popupArticle && e.key == "Escape"){
          this.popupArticle = null
        }
      })

      window.coolHelperFunctions.coolAjax({
        action: 'fetch_freshdesk_data'
      }, success => {
        this.loading = false
        if(success?.data?.directory?.length){
          this.directory = success.data.directory
        } else {
          alert('Something went wrong, please try again later.')
        }
      }, error => {
        this.loading = false
        alert(`Something when wrong, please try again later. ${error}`)
      })
    },
    watch: {
      popupArticle(){
        if(this.popupArticle){
          const scrollY = window.scrollY
          document.body.style.top = `-${scrollY}px`
          document.body.style.position = 'fixed'
          document.body.style.width = '100%'
          setTimeout(() => {
            const el = document.querySelector('.freshdesk--popup-article')
            el.setAttribute('tabindex', -1)
            el.focus()
          })
          document.querySelector('html').classList.add('freshdesk-popup-open')
        } else {
          const scrollY = parseInt(document.body.style.top || '0') * -1
          document.body.style.position = ''
          document.body.style.top = ''
          document.body.style.width = ''
          window.scrollTo(0, scrollY)
          document.querySelector('html').classList.remove('freshdesk-popup-open')
        }
      }
    }    
  }

  function initApp(){
    const els = document.querySelectorAll('.freshdesk--app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}